export class BookingReminder {
    constructor(
        public id: string,
        public sentDateTime: Date,
        public confirmedDateTime: Date | null
    ) { }
}
